/* src/app/manage-videos/manage-videos.component.scss */
.title {
  margin: 0 20px 20px 20px;
  font-size: 1.5rem;
}
.filter-row input[type=text] {
  line-height: 2rem;
  width: 150px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 14px;
  margin: 0;
}
.mat-column-id {
  max-width: 160px;
}
.mat-column-bunny_id {
  max-width: 300px;
}
.mat-column-title {
  min-width: 300px;
}
.mat-column-thumbnail {
  max-width: 140px;
}
.mat-column-actions {
  flex: 0 0 80px !important;
  justify-content: flex-end;
}
.thumbnail-cell {
  max-width: 100px;
  max-height: 56px;
  border-radius: 4px;
}
.action-btn {
  color: #333;
  text-decoration: underline !important;
  cursor: pointer;
}
/*# sourceMappingURL=manage-videos.component.css.map */
